import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import JobPosting from "@/views/JobPosting.vue";
import Blogs from "@/views/Blogs.vue";
import ContactUs from "@/views/ContactUs.vue";
import SubmitProfile from "@/views/SubmitProfile.vue";
import TermsAndConditions from "@/views/TermsAndConditions.vue";

Vue.use(VueRouter);

import VueMeta from "vue-meta";
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});

const routes = [
  {
    path: "/",
    name: "Finult",
    component: Home
  },
  {
    path: "/#home",
    name: "Home",
    component: Home
  },
  {
    path: "/#services",
    name: "Services",
    component: Home
  },
  {
    path: "/#testimonials",
    name: "Testimonials",
    component: Home
  },
  {
    path: "/job-posting",
    name: "JobPosting",
    component: JobPosting
  },
  {
    path: "/#about-us",
    name: "AboutUs",
    component: Home
  },
  {
    path: "/blogs",
    name: "Blogs",
    component: Blogs
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: ContactUs
  },
  {
    path: "/share-profile",
    name: "SubmitProfile",
    component: SubmitProfile
  },
  {
    path: "/terms-conditions",
    name: "TermsAndConditions",
    component: TermsAndConditions
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkExactActiveClass: "exact-active",
  routes
});

export default router;
